import { apiConstants } from "../../config";
import {
  apiPost,
  apiPut,
  apiGet,
  apiDelete
} from "../../../../shared/services";

const fetchItems = async options => {
  const url = apiConstants.url;
  return await apiGet(url, { params: options });
};

const saveItem = async (id, data, validator) => {
  if (id) {
    let url = apiConstants.url + "/" + id;
    return await apiPut(url, { ...data }, validator);
  } else {
    let url = apiConstants.url;
    return await apiPost(url, { ...data }, validator);
  }
};

const fetchItem = async id => {
  const url = apiConstants.url;
  return await apiGet(url + "/" + id);
};

const deleteItem = async id => {
  const url = apiConstants.url;
  return await apiDelete(url + "/" + id);
};

const saveProductionAuthorizations = async (id, data, validator) => {
  let url = apiConstants.url + "/" + id + "/productionauthorizations";
  return await apiPut(url, { ...data }, validator);
};

const fetchLabeltypes = async options => {
  const url = apiConstants.labeltypes;
  return await apiGet(url, { params: options });
};

const saveLastNo = async (id, numberrange, data, validator) => {
  let url = apiConstants.url + "/" + id + "/setlastno/" + numberrange;
  return await apiPut(url, { ...data }, validator);
};

export {
  fetchItems,
  saveItem,
  deleteItem,
  fetchItem,
  saveProductionAuthorizations,
  fetchLabeltypes,
  saveLastNo
};
